import { render, staticRenderFns } from "./ActivityForm.vue?vue&type=template&id=48287b1d&"
import script from "./ActivityForm.vue?vue&type=script&lang=js&"
export * from "./ActivityForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48287b1d')) {
      api.createRecord('48287b1d', component.options)
    } else {
      api.reload('48287b1d', component.options)
    }
    module.hot.accept("./ActivityForm.vue?vue&type=template&id=48287b1d&", function () {
      api.rerender('48287b1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chooseSeat/ActivityManage/modules/ActivityForm.vue"
export default component.exports